import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';

const ItemNotFound = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 4, width: '100%', minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box sx={{ maxWidth: 520, textAlign: 'center' }}>
        <Stack direction="column" spacing={3} alignItems="center">
          <ErrorOutlinedIcon sx={{ fontSize: 72, color: 'error.main' }} />
          <Typography variant="h3" sx={{ fontWeight: 700 }}>
            Item not found
          </Typography>
          <Typography variant="body1" color="text.secondary">
            The requested inventory item could not be found. It may have been removed or never existed.
          </Typography>
          <Button variant="contained" size="large" onClick={() => navigate('/dashboard/items')}>
            Back to Items
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default ItemNotFound;
